import { object, string } from 'yup';
export const Fields = [
  {
    name: 'email',
    placeholder: 'Email',
    label: 'Email',
  },
  {
    name: 'password',
    placeholder: 'Password',
    label: 'Password',
    password: true,
    helper: true,
  },
];
export const validationSchema = object({
  email: string()
    .required('Required')
    .email('Enter a valid email address!')
    .nullable(),
  password: string().required('Required'),
});
export const initialValues = {
  email: '',
  password: '',
};
